import Vue from 'vue';
import PageContent from './_components/EventsIndex';

(function() {
    new Vue({
        el: '#vueable',

        components: {
            PageContent,
        },

        template: `<PageContent />`,
    });
})();
